<div page-content [fullWidth]="true">
  <div actions class="uk-section-primary uk-preserve-color">
    <sidebar-mobile-toggle class="uk-hidden@m uk-display-block uk-padding-small"></sidebar-mobile-toggle>
  </div>
  <div inner>
    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent>
      <div class="uk-container">

        <div class="uk-flex uk-flex-between uk-flex-middle uk-visible@m">
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
                 class="flag-image uk-margin-small-right" width="42" height="42" alt="rounded flag image">
            <h4 class="uk-margin-remove">{{ countryName }} - Open Science for {{ year }}</h4>
          </div>
          <div class="uk-flex uk-flex-center"
               (click)="exportToPDF([exportContent, exportContent1, exportContent2], 'General R&D Overview')"
               style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary"
                 style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class=""
                    style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                      data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>

        <div class="uk-hidden@m">
          <div class="uk-flex uk-flex-middle uk-margin-bottom">
            <img ngSrc="../../survey-tool/assets/images/flags/{{flagCode | lowercase}}-flag-round.png"
                 class="flag-image uk-margin-small-right" width="42" height="42" alt="rounded flag image">
            <h4 class="uk-margin-remove">{{ countryName }} - Open Science for {{ year }}</h4>
          </div>
          <!--          <h4>General R&D Overview</h4>-->
          <div class="uk-flex uk-flex-right"
               (click)="exportToPDF([exportContent, exportContent1, exportContent2], 'General R&D Overview')"
               style="cursor: pointer">
            <div class="uk-flex uk-flex-middle uk-text-primary"
                 style="background-color: #DAEEF3; border-radius: 30px; padding: 5px 7px">
              <span class=""
                    style="background-color: #fff; border-radius: 50px; border: 1px solid #008691; padding: 4px 10px">
                Export report
              </span>
              @if (exportActive) {
                <span class="uk-margin-small-left"
                      data-uk-spinner="ratio: 0.7"></span>
              } @else {
                <span class="material-symbols-outlined filled uk-margin-small-left uk-text-primary">download</span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-hidden-notice-band">
      <div class="uk-container">
        <app-section-hidden-notice sectionName="General R&D Overview"></app-section-hidden-notice>
      </div>
    </div>

    <div class="uk-section uk-section-primary uk-preserve-color uk-section-small" #exportContent1>
      <div class="uk-container">

        <div class="uk-flex uk-flex-between uk-flex-middle">
          <h5>General Overview of R&D and Open Science</h5>
        </div>

        <div class="uk-grid-small uk-grid-match uk-grid" data-uk-grid>

          @if (hasAnyLeftCardVisible()) {
            <div class="uk-width-1-1 uk-width-3-5@m uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body">
                <div
                  class="uk-child-width-1-1@s uk-child-width-1-2@m uk-grid-small uk-grid-match uk-flex uk-flex-center"
                  data-uk-grid
                  data-uk-height-match="target: > * .uk-card">
                  <!-- Card 1 -->
                  <app-card-config indicatorId="1" colorClass="openaire-graph visualisation-card">
                  @if (OAPubsPercentage[1] !== null) {
                    <app-info-card
                      [titleHtml]="'OA Publication in ' + countryName + ' (OA vs Closed)'" [value]="OAPubsPercentage[1]"
                      unit="%" [diff]="OAPubsPercentageDiff" colorClass="openaire-graph visualisation-card">
                    </app-info-card>
                  }
                  </app-card-config>
                  <!-- Card 2 -->
                  <app-card-config indicatorId="2" colorClass="openaire-graph visualisation-card">
                  @if (OpenDataPercentage[1] !== null) {
                    <app-info-card
                      [titleHtml]="'Open Data in ' + countryName + ' (OA vs Closed)'" [value]="OpenDataPercentage[1]"
                      unit="%" [diff]="OpenDataPercentageDiff" colorClass="openaire-graph visualisation-card">
                    </app-info-card>
                  }
                  </app-card-config>
                  <!-- Card 3 -->
                  <app-card-config indicatorId="3" colorClass="eosc-sb visualisation-card">
                  @if (totalInvestment[1] !== null) {
                    <app-info-card titleHtml="Total investment in EOSC and Open Science"
                                   [value]="totalInvestment[1]" unit="mil Euro" [diff]="investmentPercentageDiff"
                                   colorClass="eosc-sb visualisation-card">
                    </app-info-card>
                  }
                  </app-card-config>
                  <!-- Card 4 -->
                  <app-card-config indicatorId="4" colorClass="eosc-sb visualisation-card">
                  @if (openSoftware[1] !== null) {
                    <app-info-card
                      titleHtml="Number of Open Software sets published in {{ countryName }}" [value]="openSoftware[1]"
                      unit="sets" [diff]="openSoftwarePercentageDiff" colorClass="eosc-sb visualisation-card">
                    </app-info-card>
                  }
                  </app-card-config>
                </div>
              </div>
            </div>
          }

          <!-- Right Card (2/5) -->
          <app-card-config indicatorId="5" class="uk-width-1-1 uk-width-2-5@m uk-animation-fade">
          <div>
            <div class="uk-card uk-card-default uk-card-body external-sources visualisation-card">
              <h5>R&D Information</h5>

              <div class="uk-child-width-1-2 uk-grid-small uk-grid-match uk-grid" data-uk-grid>

                @if (rfos[1]) {
                  <div>
                    <div class="">
                      <p>Number of research funding organisations</p>
                      <div class="number big uk-margin">
                        <span class="uk-text-bold">{{ rfos[1] }}</span>
                      </div>
                      @if (rfosPercentageDiff !== null) {
                        <div
                          class="uk-flex uk-flex-bottom uk-flex-between uk-width-1-1">
                          <div class="uk-flex uk-flex-middle">
                        <span class="material-symbols-outlined" [ngClass]="{
                            'up-arrow-color': rfosPercentageDiff > 0,
                            'down-arrow-color': rfosPercentageDiff < 0,
                            'neutral-arrow-color': rfosPercentageDiff === 0
                          }">
                              {{ rfosPercentageDiff > 0 ? 'arrow_upward' : rfosPercentageDiff < 0 ? 'arrow_downward' : 'commit' }}
                            </span>
                            <span [ngClass]="{
                          'percentage-up-color': rfosPercentageDiff > 0,
                          'percentage-down-color': rfosPercentageDiff < 0,
                          'percentage-neutral-color': rfosPercentageDiff === 0 }">
                              {{ Math.abs(rfosPercentageDiff) }}%
                            </span>&nbsp; from last year
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }

                @if (rpos[1]) {
                  <div>
                    <div class="">
                      <p>Number of research performing organisations</p>
                      <div class="number big uk-margin">
                        <span class="uk-text-bold">{{ rpos[1] }}</span>
                      </div>
                      @if (rposPercentageDiff !== null) {
                        <div
                          class="uk-flex uk-flex-bottom uk-flex-between uk-width-1-1">
                          <div class="uk-flex uk-flex-middle">
                        <span class="material-symbols-outlined" [ngClass]="{
                            'up-arrow-color': rposPercentageDiff > 0,
                            'down-arrow-color': rposPercentageDiff < 0,
                            'neutral-arrow-color': rposPercentageDiff === 0
                          }">
                              {{ rposPercentageDiff > 0 ? 'arrow_upward' : rposPercentageDiff < 0 ? 'arrow_downward' : 'commit' }}
                            </span>
                            <span [ngClass]="{
                          'percentage-up-color': rposPercentageDiff > 0,
                          'percentage-down-color': rposPercentageDiff < 0,
                          'percentage-neutral-color': rposPercentageDiff === 0 }">
                              {{ Math.abs(rposPercentageDiff) }}%
                            </span>&nbsp; from last year
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }

              </div>
            </div>
          </div>
          </app-card-config>

          <div>
            <p><span class="uk-text-bold">Data source:</span>
              Survey on National Contributions to EOSC and Open Science {{ year }} -
              showing data for {{ year }}, except financial contributions, which reflect the previous year
              ({{ +year - 1 }});
              OpenAIRE Graph data for {{ year }} (updated on {{ lastUpdateDate }}).
            </p>
          </div>
        </div>
      </div>
    </div>


    @if (countryNewsItems.length > 0) {
      <div class="uk-section uk-section-primary uk-preserve-color uk-section-small">
        <div class="uk-container">
          <app-card-config indicatorId="6">
          <h5>Latest News</h5>

          @if (countryNewsItems.length <= 3) {
            <!-- Grid layout for 1–3 items -->
            <div class="uk-grid-small uk-child-width-1-1 uk-child-width-1-3@m uk-grid-match" data-uk-grid>
              @for (item of countryNewsItems; track item.id) {
                <div>
                  <div class="uk-card" style="border-radius: 8px; overflow: hidden; border: 1px solid #e5e5e5;">
                    @if (item.image) {
                      <img [src]="item.image"
                           style="width: 100%; height: 200px; object-fit: cover; display: block;"
                           [alt]="item.title">
                    }
                    <div class="uk-card-body">
                      <p class="uk-text-meta uk-margin-remove-bottom">
                        {{ item.publishDate | date:'dd MMMM yyyy' }}
                      </p>
                      <h5 class="uk-text-bold uk-margin-small-top uk-margin-small-bottom">
                        {{ item.title }}
                      </h5>
                      <p class="uk-text-small multi-line-ellipsis" style="-webkit-line-clamp: 5">
                        {{ item.description }}
                      </p>
                      @if (item.url) {
                        <a [href]="item.url" target="_blank"
                           class="uk-button uk-button-primary uk-button-small uk-border-rounded uk-margin-small-top">
                          Read more
                        </a>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <!-- Slider layout for 4+ items -->
            <div class="uk-position-relative" data-uk-slider>
              <div class="uk-slider-container">
                <ul class="uk-slider-items uk-grid-small uk-grid-match" data-uk-grid>
                  @for (item of countryNewsItems; track item.id) {
                    <li class="uk-width-1-3@m uk-width-1-2@s uk-width-1-1">
                      <div class="uk-card" style="border-radius: 8px; overflow: hidden; border: 1px solid #e5e5e5;">
                        @if (item.image) {
                          <img [src]="item.image"
                               style="width: 100%; height: 200px; object-fit: cover; display: block;"
                               [alt]="item.title">
                        }
                        <div class="uk-card-body">
                          <p class="uk-text-meta uk-margin-remove-bottom">
                            {{ item.publishDate | date:'dd MMMM yyyy' }}
                          </p>
                          <h5 class="uk-text-bold uk-margin-small-top uk-margin-small-bottom">
                            {{ item.title }}
                          </h5>
                          <p class="uk-text-small multi-line-ellipsis" style="-webkit-line-clamp: 5">
                            {{ item.description }}
                          </p>
                          @if (item.url) {
                            <a [href]="item.url" target="_blank"
                               class="uk-button uk-button-primary uk-button-small uk-border-rounded uk-margin-small-top">
                              Read more
                            </a>
                          }
                        </div>
                      </div>
                    </li>
                  }
                </ul>
              </div>
              <a class="uk-position-center-left uk-position-small" href="#" data-uk-slidenav-previous
                 data-uk-slider-item="previous"></a>
              <a class="uk-position-center-right uk-position-small" href="#" data-uk-slidenav-next
                 data-uk-slider-item="next"></a>
            </div>
          }
        </app-card-config>
        </div>
      </div>
    }


    <div #exportContent2>
      @if (hasSurveyGeneralData()) {
        <div class="uk-section uk-section-primary uk-preserve-color uk-section-xsmall">
          <div class="uk-container">
            <app-card-config indicatorId="7">
            <div class="uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body uk-width-1-1 noads visualisation-card">
                <h6 class="uk-margin-bottom">Learn more about Open Science Key Actors in {{ countryName }}</h6>
                <div class="uk-text-meta">This information has been compiled by the National Open Access Desks
                  on {{ countrySurveyAnswerLastUpdate | date: 'yyyy-MM-dd' }}
                </div>
                <div class="uk-margin-medium-top">
                  <read-more [maxHeight]="300">
                    <div id="research_funding_organisations">
                      <div class="uk-text-secondary uk-margin-small-bottom">Research Funding Organisations</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question2']?.length > 0 && countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question2'][0]['Question2-1']) {
                        @for (element of countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question2']; track element) {
                          <div class="uk-margin-remove-top">
                            <div [innerHTML]="element['Question2-1']"></div>
                          </div>
                        }
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                    <div id="research_performing_organisations" class="uk-margin-medium-top">
                      <div class="uk-text-secondary uk-margin-small-bottom">Research Performing Organisations</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question3']?.length > 0 && countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question3'][0]['Question3-1']) {
                        @for (element of countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question3']; track element) {
                          <div class="uk-margin-remove-top">
                            <div [innerHTML]="element['Question3-1']"></div>
                          </div>
                        }
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                    <div id="research_support_organisations" class="uk-margin-medium-top">
                      <div class="uk-text-secondary uk-margin-small-bottom">Research Support Organisations</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question4']?.length > 0 && countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question4'][0]['Question4-1']) {
                        @for (element of countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question4']; track element) {
                          <div class="uk-margin-remove-top">
                            <div [innerHTML]="element['Question4-1']"></div>
                          </div>
                        }
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                    <div id="other_organisations" class="uk-margin-medium-top">
                      <div class="uk-text-secondary uk-margin-small-bottom">Other Organisations</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question30']?.length > 0 && countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question30'][0]['Question30-1']) {
                        @for (element of countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question30']; track element) {
                          <div class="uk-margin-remove-top">
                            <div [innerHTML]="element['Question30-1']"></div>
                          </div>
                        }
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                  </read-more>
                </div>
              </div>
            </div>
            </app-card-config>
          </div>
        </div>


        <div class="uk-section uk-section-primary uk-preserve-color uk-section-xsmall">
          <div class="uk-container">
            <app-card-config indicatorId="8">
            <div class="uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body uk-width-1-1 noads visualisation-card">
                <h6 class="uk-margin-bottom">Learn more about Open Science Initiatives in {{ countryName }}</h6>
                <div class="uk-text-meta">This information has been compiled by the National Open Access Desks
                  on {{ countrySurveyAnswerLastUpdate | date: 'yyyy-MM-dd' }}
                </div>
                <div class="uk-margin-medium-top">
                  <read-more [maxHeight]="300">
                    <div id="eosc_national">
                      <div class="uk-text-secondary uk-margin-small-bottom">EOSC National Initiative</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']?.['Question5']?.['Question5-1']) {
                        <div class="uk-margin-remove-top"
                             [innerHTML]="countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question5']['Question5-1']"></div>
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                    <div id="os_fair" class="uk-margin-medium-top">
                      <div class="uk-text-secondary uk-margin-small-bottom">Open Science and FAIR National Initiatives</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']?.['Question6']?.length > 0) {
                        @for (init of countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question6']; track init) {
                          <div class="uk-margin-remove-top" [innerHTML]="init['Question6-1']"></div>
                        }
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                    <div id="oa_publishing" class="uk-margin-medium-top">
                      <div class="uk-text-secondary uk-margin-small-bottom">Open Access Publishing</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']?.['Question7']) {
                        <div class="uk-margin-remove-top"
                             [innerHTML]="countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question7']"></div>
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                    <div id="regional_global" class="uk-margin-medium-top">
                      <div class="uk-text-secondary uk-margin-small-bottom">Regional / EC / Global Initiatives</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']?.['Question8']?.length > 0) {
                        @for (init of countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question8']; track init) {
                          <div class="uk-margin-remove-top" [innerHTML]="init['Question8-1']"></div>
                        }
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                    <div id="miscellaneous" class="uk-margin-medium-top">
                      <div class="uk-text-secondary uk-margin-small-bottom">Miscellaneous</div>
                      @if (countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']?.['Question9']) {
                        <div class="uk-margin-remove-top"
                             [innerHTML]="countrySurveyAnswer['SCIENCE, TECHNOLOGY & INNOVATION - STI POLICY FRAMEWORK']['Question9']"></div>
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                  </read-more>
                </div>
              </div>
            </div>
            </app-card-config>
          </div>
        </div>



        <div class="uk-section uk-section-primary uk-preserve-color uk-section-xsmall">
          <div class="uk-container">
            <app-card-config indicatorId="9">
            <div class="uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body uk-width-1-1 noads visualisation-card">
                <h6 class="uk-margin-bottom">Monitoring Infrastructure in {{ countryName }}</h6>
                <div class="uk-margin-medium-top">
                  <read-more [maxHeight]="300">
                    <div id="monitoring_mechanisms">
                      <div class="uk-text-secondary uk-margin-small-bottom">Mechanisms to monitor data infrastructure and services</div>
                      @if (countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']?.['Question21']?.['Question21-1']) {
                        <div class="uk-margin-remove-top"
                             [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question21']['Question21-1']"></div>
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                  </read-more>
                </div>
              </div>
            </div>
            </app-card-config>
          </div>
        </div>


        <div class="uk-section uk-section-primary uk-preserve-color uk-section-xsmall">
          <div class="uk-container">
            <app-card-config indicatorId="10">
            <div class="uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body uk-width-1-1 noads visualisation-card">
                <h6 class="uk-margin-bottom">Links to European and Global Infrastructures</h6>
                <div class="uk-margin-medium-top">
                  <read-more [maxHeight]="300">
                    <div id="european_global_links">
                      @if (countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']?.['Question23']?.['Question23-1']) {
                        <div class="uk-margin-remove-top"
                             [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question23']['Question23-1']">
                        </div>
                      }
                      @if (!countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']?.['Question23']?.['Question23-1']) {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                  </read-more>
                </div>
              </div>
            </div>
            </app-card-config>
          </div>
        </div>

        <div class="uk-section uk-section-primary uk-preserve-color uk-section-xsmall">
          <div class="uk-container">
            <app-card-config indicatorId="11">
            <div class="uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body uk-width-1-1 noads visualisation-card">
                <h6 class="uk-margin-bottom">Authentication and Authorization Infrastructure (AAI) and AARC</h6>
                <div class="uk-margin-medium-top">
                  <read-more [maxHeight]="300">
                    <div>
                      <div class="uk-text-secondary uk-margin-small-bottom">National AAI and AARC Framework</div>
                      @if (countrySurveyAnswer['OPEN_SCIENCE_DIGITAL_INFRASTRUCTURE']?.['Question32']?.['Question32-1']) {
                        <div class="uk-margin-remove-top"
                             [innerHTML]="countrySurveyAnswer['OPEN_SCIENCE_DIGITAL_INFRASTRUCTURE']['Question32']['Question32-1']">
                        </div>
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                    <div class="uk-margin-medium-top">
                      <div class="uk-text-secondary uk-margin-small-bottom">Primary Authentication and Authorization Services</div>
                      @if (countrySurveyAnswer['OPEN_SCIENCE_DIGITAL_INFRASTRUCTURE']?.['Question32']?.['Question32-2']) {
                        <div class="uk-margin-remove-top"
                             [innerHTML]="countrySurveyAnswer['OPEN_SCIENCE_DIGITAL_INFRASTRUCTURE']['Question32']['Question32-2']">
                        </div>
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                  </read-more>
                </div>
              </div>
            </div>
            </app-card-config>
          </div>
        </div>

        <div class="uk-section uk-section-primary uk-preserve-color uk-section-xsmall">
          <div class="uk-container">
            <app-card-config indicatorId="12">
            <div class="uk-animation-fade">
              <div class="uk-card uk-card-default uk-card-body uk-width-1-1 noads visualisation-card">
                <h6 class="uk-margin-bottom">Cloud Services</h6>
                <div class="uk-margin-medium-top">
                  <read-more [maxHeight]="400">
                    <div id="cloud_services_content">
                      @if (countrySurveyAnswer['OPEN_SCIENCE_DIGITAL_INFRASTRUCTURE']?.['Question33']) {
                        <div class="uk-margin-remove-top"
                             [innerHTML]="countrySurveyAnswer['OPEN_SCIENCE_DIGITAL_INFRASTRUCTURE']['Question33']">
                        </div>
                      } @else {
                        <p class="uk-margin-remove-top">N/A</p>
                      }
                    </div>
                  </read-more>
                </div>
              </div>
            </div>
            </app-card-config>
          </div>
        </div>
      }
    </div>
  </div>
</div>
